export default __webpack_public_path__ + "static/developer-be453c7544eba8e513e3145f763b6e04.png";